export default __webpack_public_path__ + "static/media/icon-384x384.e45fa404.png";